module.exports = __webpack_public_path__ + "static/media/parachute-box.c34b2853.svg";